import dayjs from "dayjs";
import * as XLSX from "xlsx";

export class CommonUtils {
  public dateFormat = (value: string, iPattern: string, oPattern: string) => {
    return dayjs(value, iPattern).format(oPattern);
  };

  public convertSecToTime = (timeInSeconds: number) => {
    let hours: any = Math.floor(timeInSeconds / 3600);
    let minutes: any = Math.floor((timeInSeconds - hours * 3600) / 60);
    let seconds: any = Math.floor(timeInSeconds - hours * 3600 - minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }

    if (hours > 99) {
      hours = this.numericComma(Number(hours));
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return {
      hours: "" + hours,
      minutes: "" + minutes,
      seconds: "" + seconds,
    };
  };

  public isEmptyObj(obj: any) {
    if (obj === null || obj === undefined) return true;
    if (obj.constructor === Object && Object.keys(obj).length > 0) {
      return false;
    }

    return true;
  }

  public numericComma = (value: any) => {
    if (typeof value === "number") {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return undefined;
  };

  public downloadExcel = (sheetContent: any, colWidth: any, sheetName: string, fileName: string) => {
    const sheet: any = XLSX.utils.aoa_to_sheet(sheetContent);
    sheet["!cols"] = colWidth;
    const chatFile = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(chatFile, sheet, sheetName);
    XLSX.writeFile(chatFile, fileName);
  };

  public calculateWindowSize = (windowWidth: number) => {
    if (windowWidth >= 1200) {
      return "lg";
    }
    if (windowWidth >= 1024) {
      return "md";
    }
    if (windowWidth >= 1023) {
      return "sm";
    }
    // if (windowWidth >= 992) {
    //   return "md";
    // }
    // if (windowWidth >= 768) {
    //   return "sm";
    // }
    return "xs";
  };

  public calRemainSec = (startTime: string) => {
    const now = dayjs();
    const dateDiff = dayjs(startTime, "YYYYMMDDHHmmss").diff(now, "s");
    return dateDiff;
  };

  // 국가코드별 국기 이미지 생성기
  public makeCtryFlagUrl = (code: string) => {
    return `${process.env.REACT_APP_DT_IMAGE_DOMAIN}../../public/images/aihdt/flag/flag_${code.toLowerCase()}.png`;
  };

  public getDupIndex = (arr: any, obj: any, key: string) => {
    // 중복 체크
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][key] === obj[key]) {
        return i;
      }
    }
    return -1;
  };

  public mergeJsonList = (jsonList: any, compareKey: string, mergeKey: string) => {
    let result: any = [];
    for (const obj of jsonList) {
      const idx = this.getDupIndex(result, obj, compareKey);
      if (idx > -1) {
        result[idx][mergeKey] += Number(obj[mergeKey]);
      } else {
        let json: any = {};
        json[compareKey] = obj[compareKey];
        json[mergeKey] = obj[mergeKey];
        result.push(json);
      }
    }
    return result;
  };

  public jsonListSort = (list: any, sortKey: string) => {
    let result: any = [...list];
    result.sort((a: any, b: any) => {
      if (a[sortKey] < b[sortKey]) return 1;
      if (a[sortKey] > b[sortKey]) return -1;
      return 0;
    });
    return result;
  };

  public genRefSiteLogo = (url: string) => {
    if (url === "") return "";
    let imageUrl = "";
    const { hostname } = new URL(url);
    if (hostname === "wwd.com") {
      imageUrl = "/images/icon-wwd.png";
    } else if (hostname === "hypebeast.kr") {
      imageUrl = "/images/icon-hb.png";
    } else if (hostname === "www.eyesmag.com") {
      imageUrl = "/images/icon-eyesmag.png";
    } else if (hostname === "techcrunch.com") {
      imageUrl = "/images/icon-techcrunch.png";
    } else if (hostname === "www.dezeen.com") {
      imageUrl = "/images/icon-dezeen.png";
    } else if (hostname === "apparelnews.co.kr") {
      imageUrl = "/images/icon-apparelnews.png";
    } else if (hostname === "www.businessoffashion.com") {
      imageUrl = "/images/icon-bof.png";
    } else if (hostname === "www.designscene.net") {
      imageUrl = "/images/icon-ds.png";
    } else if (hostname === "www.artnews.com") {
      imageUrl = "/images/icon-artnews.png";
    } else if (hostname === "fashionbiz.co.kr") {
      imageUrl = "/images/icon-fashionbiz.png";
    } else if (hostname === "www.wallpaper.com") {
      imageUrl = "/images/icon-wallpaper.png";
    } else if (hostname === "www.wwdkorea.com") {
      imageUrl = "/images/icon-wwdkorea.png";
    } else if (hostname === "www.elle.co.kr") {
      imageUrl = "/images/icon-elle.png";
    } else if (hostname === "www.itworld.co.kr") {
      imageUrl = "/images/icon-itworld.png";
    } else if (hostname === "www.cio.com") {
      imageUrl = "/images/icon-cio.png";
    } else if (hostname === "www.boannews.com") {
      imageUrl = "/images/icon-boannews.png";
    } else if (hostname === "www.aitimes.com") {
      imageUrl = "/images/icon-aitimes.png";
    } else if (hostname === "www.etnews.com") {
      imageUrl = "/images/icon-etnews.png";
    } else if (hostname === "zdnet.co.kr") {
      imageUrl = "/images/icon-zdnet.png";
    }
    return imageUrl;
  };

  public ltrim = (value: string) => {
    return value.replace(/^\s+/, "");
  };
}
